export default __webpack_public_path__ + "static/media/new_one.9941be9c.svg";